import { fetchWithAuth } from "~/common/fetch";
import { API_BONUS_PATIENT } from "~/config";
import type { TUserActionNotification } from "~/reducers/dashboard";
import type { AppDispatch } from "~/store";
import type { TPatient } from "~/types/patient";
import type { TUser } from "~/types/user";

import { addUserActionNotification } from "./user_notification";

export function postBonusPatient(
  doctor_id: TUser["account_id"],
  patient_id: TPatient["patient_id"],
) {
  const NOTIFICATION_MSG_OK: TUserActionNotification = {
    message: "bonus.patient.set.successfully",
    level: "success",
    position: "tl",
    autoDismiss: 10,
  };

  const NOTIFICATION_MSG_ERROR: TUserActionNotification = {
    message: "bonus.patient.set.error",
    level: "error",
    position: "tl",
    autoDismiss: 11,
  };

  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchWithAuth(API_BONUS_PATIENT(doctor_id, patient_id), {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error("Error occurred trying to set bonus patient");
      }
      const json = await response.json();
      dispatch({ type: "POST_BONUS_PATIENT", json });
      dispatch(addUserActionNotification(NOTIFICATION_MSG_OK));
    } catch {
      dispatch(addUserActionNotification(NOTIFICATION_MSG_ERROR));
    }
  };
}
